// extracted by mini-css-extract-plugin
module.exports = {"sticker":"ProjectSticker_sticker__DxMnd","inner":"ProjectSticker_inner__wb_eR"};